import { Text, tokens, Divider } from '@hotjar/hotsauce';
import styled from '@emotion/styled';

const Caret = styled.svg(
  ({ isExpanded }: { isExpanded: boolean }) => `
    fill: ${tokens.BRAND_COLORS.neutral_500};
    ${!isExpanded && 'transform: rotate(-90deg);'}
`,
);

const StyledDivider = styled(Divider)`
  margin-top: 0;
`;

const CategoryButton = styled.button`
  height: ${tokens.spacer.x4};

  display: flex;
  flex-direction: row;
  align-self: stretch;
  align-items: center;
  justify-content: start;
  gap: ${tokens.spacer.x1};
  margin-bottom: ${tokens.spacer.x1};

  border-radius: ${tokens.radius.m};
  border: none;
  background: none;

  &:hover {
    background: ${tokens.color.neutral_100};
  }

  &:active {
    background: ${tokens.color.bg_active};
  }

  &:focus {
    outline: none;
    ${tokens.focus()};
  }

  &:not(:focus-visible) {
    outline: none;
    box-shadow: none;
  }

  &[disabled] {
    background-color: ${tokens.color.ui_disabled};
  }

  ${tokens.transition('background-color')};
  ${tokens.transition('box-shadow')};
`;

export interface SidebarCategoryButtonProps {
  title: string;
  isExpanded: boolean;
  hideDivider?: boolean;
  categoryId?: string;
  onClick: () => void;
}

export const SidebarCategoryButton = ({
  title,
  isExpanded,
  hideDivider,
  categoryId,
  onClick,
}: SidebarCategoryButtonProps): JSX.Element => {
  return (
    <>
      {!hideDivider ? <StyledDivider spacing="s" /> : null}
      <CategoryButton
        aria-label={title}
        aria-controls={categoryId}
        aria-expanded={isExpanded}
        onClick={onClick}
      >
        <Caret
          isExpanded={isExpanded}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          width="16"
          height="16"
          aria-hidden="true"
        >
          <path
            d="M3.683 6.82A.5.5 0 0 1 4.068 6h7.864a.5.5 0 0 1 .385.82l-3.933 4.72a.5.5 0 0 1-.768 0L3.683 6.82Z"
            fillRule="evenodd"
          />
        </Caret>
        <Text textType="subtitle2">{title}</Text>
      </CategoryButton>
    </>
  );
};
